export default __webpack_public_path__ + "static/media/52.08486269.gif";